import { isAxiosError } from 'axios'

const wonFormatter = new Intl.NumberFormat('ko-KR', { maximumFractionDigits: 0 })

export function formatWon(value: number): string {
  return wonFormatter.format(value)
}

export function formatKstDateTime(value: string): string {
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value
  return date.toLocaleString('ko-KR', {
    timeZone: 'Asia/Seoul',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

const API_ERROR_MESSAGES: Record<string, string> = {
  INVALID_DATE_RANGE: '조회 기간이 올바르지 않습니다. 시작일이 종료일보다 늦을 수 없습니다.',
  DATE_RANGE_TOO_LONG: '조회 기간은 최대 366일까지 설정할 수 있습니다.',
  INVALID_LEDGER_CHANNEL: '채널 값이 올바르지 않습니다.',
  INVALID_LEDGER_ENTRY_TYPE: '구분 값이 올바르지 않습니다.',
  FORBIDDEN: 'LC 정산 권한이 없습니다.',
}

export function describeApiError(error: unknown, fallback: string): string {
  if (isAxiosError(error)) {
    const code = (error.response?.data as { error?: { code?: string } } | undefined)?.error?.code
    if (code && API_ERROR_MESSAGES[code]) return API_ERROR_MESSAGES[code]
  }
  return fallback
}
